import * as React from 'react';
import Select from 'react-select';
import * as $ from 'jquery';


import { IInstituteList, IDepartmentList } from 'store/StateInterfaces';

//Assets
// import '../../../CoursesList/Common/Assets/course.sass';

interface IFilter {
    departmentList: any,
    instituteList: any,
    clearAllState: void,
    filterByChangeState: void,
    filterState: any,
    courseCount: any,
    reLoadCourses: any,
    actions: any
}

interface IState {
    courseInstitute: any,
    courseDepartment: any,
    searchParam: any,
}

class FilterForm extends React.Component<IFilter, IState>  {

    constructor(props) {
        super(props);

        this.state = {
            courseInstitute: null,
            courseDepartment: null,
            searchParam: null
        }
    }

    componentDidMount() {
        $("#filterForm input").bind("keypress", function (e) {
            if (e.keyCode == 13) {
                return false;
            }
        });
    }

    handleSelectChange(e, action, name, props) {
        if (action == 'clear') {
            this.setState({
                ...this.state,
                [name]: []
            });
            props.filterByChangeState(name, '');
        } else {
            let targetValue = e.value;
            this.setState({
                ...this.state,
                [name]: [{ label: targetValue, value: targetValue }]
            });
            props.filterByChangeState(name, targetValue);

        }
    }

    handleChange = (e, props) => {
        let targetName = e.target.getAttribute('name');
        let targetValue = e.target.value;
        if (targetValue.length > 0) {
            $('.filterForm .' + targetName + ' + .clear').addClass('addClear')
            this.setState({ searchParam: targetValue })
        } else {
            $('.filterForm .' + targetName + ' + .clear').removeClass('addClear')
            this.setState({ searchParam: null })
        }
        props.filterByChangeState(targetName, targetValue);

    }

    handleClearAll(e, props) {

        e.preventDefault()
        this.setState({
            courseInstitute: null,
            courseDepartment: null,
            searchParam: null
        });
        $('.filterForm input').val('')
        $('.filterForm .form-group .clear').removeClass('addClear')
        props.clearAllState();
        // props.reLoadCourses(undefined, this.state)
        // this.props.actions.loadCoursesListRequest();

    }

    handleClear = (e, props) => {

        let targetName = e.target.getAttribute('name');
        $('.filterForm .' + targetName).val('')
        $('.filterForm .' + targetName + ' + .clear').removeClass('addClear')
        // changeState(targetName, '', props)
        this.setState({ searchParam: null });
        props.filterByChangeState(targetName, '')
        props.reLoadCourses(undefined, this.state)

        // let filterparams='';
        // filterparams += '?institute__name='+ (this.state.courseDepartment!=null ? this.state.courseDepartment.value : '') 
        //                 + '&department__name='+ (this.state.courseDepartment!=null ? this.state.courseDepartment.value : '');
        // this.props.actions.loadCoursesListRequest(filterparams, this.state);
    }

    render() {
        return (
            <div id="filterForm" className="filterForm">
                <div className="filterForm-title">Filter Courses</div>
                <form className="filterForm-form" onSubmit={(e) => handleSubmit(e)}>
                    <div className="form-group">
                        <input type="text"
                            className="form-control searchParam"
                            placeholder="Course Title/ CourseCode"
                            name="searchParam"
                            onChange={(e) => this.handleChange(e, this.props)} />
                        <span className="clear"
                            onClick={(e) => this.handleClear(e, this.props)}>&times;</span>
                    </div>
                    <div className="form-group">
                        <Select
                            isClearable="true"
                            name="courseInstitute"
                            value={this.state.courseInstitute}
                            placeholder="Course Institute"
                            options={selectOptions(this.props.instituteList)}
                            onChange={(e, { action }) => {
                                this.handleSelectChange(e, action, "courseInstitute", this.props)
                            }}
                        />
                    </div>
                    <div className="form-group">
                        <Select
                            isClearable="true"
                            name="courseDepartment"
                            value={this.state.courseDepartment}
                            placeholder="Course Department"
                            className="myInput"
                            options={selectOptions(this.props.departmentList)}
                            onChange={(e, { action }) => {
                                this.handleSelectChange(e, action, "courseDepartment", this.props)
                            }}

                        />
                    </div>
                    <div className="clearAllButton">
                        <button className="bodhi-button"
                            onClick={(e) => this.handleClearAll(e, this.props)}> Clear All</button>
                    </div>
                </form>
            </div>

        )
    }
}

// const handleChange = (e, props) => {
//     let targetName = e.target.getAttribute('name');
//     let targetValue = e.target.value;
//     if(targetValue.length > 0){
//         $('.filterForm .'+targetName+' + .clear').addClass('addClear')
//     }else{
//         $('.filterForm .'+targetName+' + .clear').removeClass('addClear')
//     }
//     props.filterByChangeState(targetName, targetValue);   
// }

const changeState = (targetName, targetValue, props) => {

    props.filterByChangeState(targetName, targetValue);
}
// const handleClear = (e, props) => {

//     let targetName = e.target.getAttribute('name'); 
//     $('.filterForm .'+targetName).val('')
//     $('.filterForm .'+targetName+' + .clear').removeClass('addClear')
//     changeState(targetName, '', props)
// } 



const handleSubmit = (e) => {
    e.preventDefault()
}
const handleClicks = (props) => {
    window.location.href = `/courseware/course/${props.course.id}/`;
};

const selectOptions = (list) => {
    let options = []
    list.forEach(item => {
        options.push({ value: item.name, label: item.name });
    });
    return options;
}

export default FilterForm;